import React, { useState, useEffect } from 'react';
import { Cookies } from '../../index.js';
import { Outlet, useNavigate } from "react-router-dom";
import axios from 'axios';
import { Helmet } from "react-helmet";
// sửa lại đường dẫn import
import Homehealing from '../../community/process/homehealing.jsx';
import National_market from '../../community/process/national_market.jsx';
import Shop_vip_max from '../../shop/mainpage/vip_max.jsx';
import Convert_domain from '../../shop/mainpage/convert_domain.jsx';
import { useDispatch, useSelector } from 'react-redux';
import { update_national_market, update_latest_version } from '../../order/orders/actions.js';
import Process_main from './process_main.jsx';
import { isLocalHost } from '../../shared/host_utils.js';

function Homehust() {
  const navigate = useNavigate();
  const [sdttruyenthanh, setsdttruyenthanh] = useState(false);
  const apikey = Cookies.get('apikey') || '';
  const [type_user, settype_user] = useState('');
  const [huyen, sethuyen] = useState(false);
  const getMainDomain = () => {
    const parts = window.location.hostname.split('.');
    return parts.length > 2 ? parts[parts.length - 2] : parts[0];
  };

  const main_domain = !isLocalHost(window.location.hostname)
    ? (Cookies.get("main_domain") || getMainDomain() || "hust")
    : (Cookies.get("main_domain") || "hust");

  function xuly(data) {
    setsdttruyenthanh(data.sdttruyenthanh);
    if (data.huyen == 1) {
      sethuyen(true);
      Cookies.set('huyen', 'ok');
    }
    else {
      sethuyen(false);
    }
    if (data.type_user) {
      settype_user(data.type_user);
      Cookies.set('type_user', data.type_user);
    }
  };

  const national_market = useSelector(state => state.national_market);
  const dispatch = useDispatch();
  const set_national_market = (value) => {
    dispatch(update_national_market(value));
  };

  const set_latest_version = (value) => {
    dispatch(update_latest_version(value));
  };

  useEffect(() => {
    const national_market_cookie = Cookies.get('national_market');
    const latest_version = Cookies.get('latest_version');

    if (latest_version) {
      set_latest_version(latest_version);
    }

    if (national_market_cookie) {
      set_national_market(national_market_cookie);
    }
  }, []);
  return (
    <div>
      {main_domain == 'tecom' && (
        <Helmet>
          <title>💖 Hust Media Healing MMO💝</title>
          <meta name="description" content="Hust Media Healing MMO – nền tảng hỗ trợ tự động hóa và tối ưu quy trình cho người dùng." />
        </Helmet>
      )}
      {main_domain == 'hust' && (
        <Helmet>
          <title>Hust Media - Scalable Web Systems & Architecture</title>
          <meta name="description" content="Technical articles, practical utilities, and implementation notes on scalable web systems, architecture, integration, and stable operation." />
        </Helmet>
      )}
      {main_domain == 'nofake' && (
        <Helmet>
          <title>NoFake.wiki – Không Fake, Không Bị Lừa | Wiki học máy</title>
          <meta name="description" content="Tra cứu website, SĐT, ví, tài khoản, MXH. Hệ thống học máy phân tích tín hiệu & hành vi, chấm điểm rủi ro, nêu dấu hiệu nghi vấn và gợi ý phòng tránh." />
        </Helmet>
      )}
      <>{
        <>
          {apikey ? (
            !national_market ? (
              <National_market />
            ) : main_domain ? (
              <>
                <Shop_vip_max />
              </>
            ) : (
              <></>
            )
          ) : (
            <Process_main />
          )}
        </>
      } </>
    </div>

  )
}
export default Homehust
